<template>
  <ol
    v-if="course.program.length > 0"
    class="relative grid gap-7 overflow-hidden pb-6"
  >
    <li
      v-for="(chapter, index) in course.program"
      :key="index"
      class="relative z-0 before:absolute before:-bottom-10 before:left-[11px] before:top-2 before:-z-10 before:block before:border-l before:border-black"
      :class="{ 'before:!bottom-0': index === course.program.length - 1 }"
    >
      <div class="grid">
        <p class="flex items-start gap-2 text-left font-bold">
          <span
            class="relative left-[5px] top-[7px] mr-2 size-3 rounded-full bg-black"
          />

          {{ chapter.title }}
        </p>

        <ol class="grid gap-3 pl-8 pt-3">
          <li
            v-for="(section, sectionIndex) in chapter.sections"
            :key="sectionIndex"
          >
            <p class="flex items-start gap-2 text-sm">
              <span
                class="bg-primary-50 text-primary-950 flex h-5 w-5 shrink-0 items-center justify-center rounded text-xs font-semibold"
                :class="{
                  '!bg-primary !w-auto px-2 text-white': !!section.tag,
                }"
              >
                {{ sectionIndex + 1 }}

                <template v-if="section.tag">
                  <app-divider class="border-primary-300 mx-2" vertical />
                  {{ section.tag }}
                </template>
              </span>

              {{ section.title }}
            </p>
          </li>
        </ol>
      </div>
    </li>
  </ol>
</template>

<script setup lang="ts">
import type { CoursePageView } from "~/business-areas/course/course.model";
import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";

defineProps<{
  course: Pick<CoursePageView, "program">;
  nextSession?: CourseSessionView;
}>();
</script>
